// =============================================================================
// Child theme — front-end behaviour entry point.
//
// This file only boots modules; all logic lives in ./modules/*.js.
//
// Everything a module touches is already rendered and styled by PHP and SCSS, so
// the page stays usable before this bundle runs and every module no-ops quietly
// on a page that does not contain its markup.
//
// The modules without an `init` here — config, overlay, toast, qty and
// cart-count — are libraries the others import.
// =============================================================================

import initHeader from "./modules/header.js";
import initMobileNav from "./modules/mobile-nav.js";
import initMiniCart from "./modules/minicart.js";
import initSearch from "./modules/search.js";
import initFaq from "./modules/faq.js";
import initProductDetail from "./modules/product-detail.js";
import initAddToCart from "./modules/add-to-cart.js";
import initShopFilters from "./modules/shop-filters.js";
import initContactForm from "./modules/contact-form.js";

function boot() {
	initHeader();
	initMobileNav();
	initMiniCart();
	initSearch();
	initFaq();
	initProductDetail();
	initAddToCart();
	initShopFilters();
	initContactForm();
}

// The bundle is a deferred module, so the document is normally parsed by now.
// The readyState check covers the case where it is not.
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
